<div class="margin">
  <panel heading="{{panelHeading | translate | async}}">
    <div class="system-overview">
      <!-- <overview-image size="140" src="/Content/Images/{{systemName}}.jpg" [loading]="loadingSystems"></overview-image> -->
      <overview-image size="140" *ngIf="systemName=='Chain' " src="/Content/Images/chain.jpg"
        [loading]="loadingSystems"></overview-image>

      <overview-image size="140" *ngIf="systemName=='Frame' " src="/Content/Images/frame.jpg"
        [loading]="loadingSystems"></overview-image>

      <div class="system-overview__content">
        <div class="content__primary">
          <item-group>
            <item [label]="'Serial Number' | translate | async" [primary]="true" [loading]="loadingSystems">
              {{system.SerialNumber}}</item>
          </item-group>
        </div>
        <div class="content__secondary" style="display: flex; flex-direction: row;">
          <item-group>
            <item [label]="'Date Installed' | translate | async" [loading]="loadingSystems">{{system.DateInstalled |
              date:'dd/MMM/yyyy'}}</item>
            <item [label]="'Equipment SMU/Hourmeter at Install' | translate | async" [loading]="loadingSystems">
              {{system.SmuAtInstall}}</item>
          </item-group>

        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="system.Components.length > 0">

      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
             <th colspan="3" *ngIf="system.ShowLastFourthInspection&& system.PreviousLastLastInspectionDate!=null">{{'Prior Inspect 3' | translate | async}}</th>
            <th colspan="3" *ngIf="system.PreviousLastInspectionDate!=null">{{'Prior Inspect 2' | translate | async}}</th>
            <th colspan="3" *ngIf="system.PreviousInspectionDate!=null">{{'Prior Inspect 1' | translate | async}}</th>
            <th colspan="3" *ngIf="system.LastInspectionDate!=null">{{'Last Inspect' | translate | async}}</th>
            <th style="text-align: center">{{'Avg CMU' | translate | async}}<br>{{'Per % Wear' | translate | async}}</th>
            <th style="text-align: center">{{'Avg DOC' | translate | async}}<br>{{'Per % Wear' | translate | async}}</th>
            <th colspan="3">% Worn Today</th>
            <th colspan="3" *ngIf="system.NextPmDate!=null">{{"Next PM Service" | translate | async}}</th>
            <th colspan="3" *ngIf="system.SecondPmDate!=null">{{"2nd PM Service" | translate | async}}</th>
            <th colspan="3" *ngIf="system.FloatingDate!=null">{{"Floating Date" | translate | async}}</th>
            <th colspan="3" *ngIf="system.FloatingDate2!=null">{{"Floating Date 2nd" | translate | async}}</th>
            <th colspan="3" *ngIf="system.Show100Worn">{{"Date 100% Worn" | translate | async}}</th>
            <th colspan="3" *ngIf="system.Show120Worn">{{"Date 120% Worn" | translate | async}}</th>
          </tr>

        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>{{"Date" | translate | async}}</td>
            <td></td>
             <td colspan="3" *ngIf=" system.ShowLastFourthInspection && system.PreviousLastLastInspectionDate!=null">
              <span>
                {{system.PreviousLastLastInspectionDate |
                date: 'dd MMM yyyy'}}</span></td>
            <td colspan="3" *ngIf="system.PreviousLastInspectionDate!=null">
              <span>
                {{system.PreviousLastInspectionDate |
                date: 'dd MMM yyyy'}}</span></td>
            <td colspan="3" *ngIf="system.PreviousInspectionDate!=null">
              <span>{{system.PreviousInspectionDate | date:
                'dd MMM yyyy'}}</span></td>
            <td colspan="3" *ngIf="system.LastInspectionDate!=null">
              <span>{{system.LastInspectionDate | date: 'dd MMM yyyy'}}</span>
            </td>
            <td></td>
            <td></td>
            <td colspan="3">{{TodayDate | date: 'dd MMM yyyy'}}</td>
            <td colspan="3" *ngIf="system.NextPmDate!=null"><span style="padding-left: 10px;">{{system.NextPmDate |
                date: 'dd MMM yyyy'}}</span>

            </td>

            <td colspan="3" *ngIf="system.SecondPmDate!=null"><span style="padding-left: 10px;">
              {{system.SecondPmDate | date: 'dd MMM yyyy'}}</span>
              </td>

            <td colspan="3" *ngIf="system.FloatingDate!=null"><span style="padding-left: 10px;">
              {{system.FloatingDate | date: 'dd MMM yyyy'}}</span>
            </td>

            <td colspan="3" *ngIf="system.FloatingDate2!=null"><span style="padding-left: 10px;">{{system.FloatingDate2
                | date:
                'dd MMM yyyy'}}</span></td>
            <td colspan="3" *ngIf="system.Show100Worn"></td>
            <td colspan="3" *ngIf="system.Show120Worn"></td>
          </tr>
          <tr>
            <td></td>
            <td>{{"SMU" | translate | async}}</td>
            <td></td>
            <td colspan="3" *ngIf="system.ShowLastFourthInspection&& system.PreviousLastLastInspectionDate!=null"><span>{{system.PreviousLastLastSMU}}</span></td>
            <td colspan="3" *ngIf="system.PreviousLastInspectionDate!=null"><span>{{system.PreviousLastSMU}}</span></td>
            <td colspan="3" *ngIf="system.PreviousInspectionDate!=null"><span>{{system.PreviousSMU}}</span></td>
            <td colspan="3" *ngIf="system.LastInspectionDate!=null"><span>{{system.LastSMU}}</span></td>
            <td></td>
            <td></td>
            <td colspan="3">{{system.ForecastSmu}}</td>
            <td colspan="3" *ngIf="system.NextPmDate!=null"><span style="padding-left: 10px;">{{system.NextSMU}}</span>
            </td>

            <td colspan="3" *ngIf="system.SecondPmDate!=null"><span
                style="padding-left: 10px;">{{system.SecondSMU}}</span></td>

            <td colspan="3" *ngIf="system.FloatingDate!=null"> <span
                style="padding-left: 10px;">{{system.FloatingSMU}}</span></td>

            <td colspan="3" *ngIf="system.FloatingDate2!=null"> <span
                style="padding-left: 10px;">{{system.FloatingSMU2}}</span>
            </td>
            <td colspan="3" *ngIf="system.Show100Worn"></td>
            <td colspan="3" *ngIf="system.Show120Worn"></td>
          </tr>
          <tr>
            <td></td>
            <td>{{"Distance" | translate | async}} ({{userUOD}})</td>
            <td></td>
             <td colspan="3" *ngIf=" system.ShowLastFourthInspection && system.PreviousLastLastInspectionDate!=null"><span>{{convertDistanceKmToMi(system.PreviousLastLastDistance)}}</span>
            </td>
            <td colspan="3" *ngIf="system.PreviousLastInspectionDate!=null"><span>{{convertDistanceKmToMi(system.PreviousLastDistance)}}</span>
            </td>
            <td colspan="3" *ngIf="system.PreviousInspectionDate!=null"><span>{{ convertDistanceKmToMi(system.PreviousDistance)}}</span></td>
            <td colspan="3" *ngIf="system.LastInspectionDate!=null"><span>{{ convertDistanceKmToMi(system.LastDistance)}}</span></td>
            <td></td>
            <td></td>
            <td colspan="3">{{ convertDistanceKmToMi(system.ForecastDistance)}}</td>
            <td colspan="3"><span *ngIf="system.NextPmDate!=null"
                style="padding-left: 10px;">{{ convertDistanceKmToMi(system.NextDistance)}}</span></td>
            <td colspan="3"><span *ngIf="system.SecondPmDate!=null"
                style="padding-left: 10px;">{{ convertDistanceKmToMi(system.SecondDistance)}}</span>
            </td>
            <td colspan="3"><span *ngIf="system.FloatingDate!=null"
                style="padding-left: 10px;">{{ convertDistanceKmToMi(system.FloatingDistance)}}</span>
            </td>
            <td colspan="3"><span *ngIf="system.FloatingDate2!=null"
                style="padding-left: 10px;">{{convertDistanceKmToMi(system.FloatingDistance2)}}</span>
            </td>
            <td colspan="3" *ngIf="system.Show100Worn"></td>
            <td colspan="3" *ngIf="system.Show120Worn"></td>
          </tr>
          <tr>
            <td></td>
            <td style="height: 40px;">{{'Component' | translate | async}}</td>
            <td>{{'Pos.' | translate | async}}</td>

            <td class="bold" *ngIf="system.ShowLastFourthInspection && system.PreviousLastLastInspectionDate!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="system.ShowLastFourthInspection && system.PreviousLastLastInspectionDate!=null">CMU<br>DOC</td>
            <td class="bold" *ngIf="system.ShowLastFourthInspection && system.PreviousLastLastInspectionDate!=null"> {{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}}</td>

            <td class="bold" *ngIf="system.PreviousLastInspectionDate!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="system.PreviousLastInspectionDate!=null">{{'CMU' | translate | async}}<br>{{'DOC' | translate | async}}</td>
            <td class="bold" *ngIf="system.PreviousLastInspectionDate!=null"> {{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}} </td>
            
            <td class="bold" *ngIf="system.PreviousInspectionDate!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="system.PreviousInspectionDate!=null">{{'CMU' | translate | async}}<br>{{'DOC' | translate | async}} </td>
            <td class="bold" *ngIf="system.PreviousInspectionDate!=null"> {{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}}</td>
            <td class="bold" *ngIf="system.LastInspectionDate!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="system.LastInspectionDate!=null">{{'CMU' | translate | async}}<br>{{'DOC' | translate | async}}</td>
            <td class="bold" *ngIf="system.LastInspectionDate!=null">{{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}}</td>
            <td></td>
            <td></td>
            <td class="bold" *ngIf="TodayDate!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="TodayDate!=null">{{'CMU' | translate | async}}<br>{{'DOC' | translate | async}}</td>
            <td class="bold" *ngIf="TodayDate!=null"> {{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}}</td>

            <td class="bold" *ngIf="system.NextPmDate!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="system.NextPmDate!=null">{{'CMU' | translate | async}}<br>{{'DOC' | translate | async}}</td>
            <td class="bold" *ngIf="system.NextPmDate!=null"> {{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}} </td>
            <td class="bold" *ngIf="system.SecondPmDate!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="system.SecondPmDate!=null">{{'CMU' | translate | async}}<br>{{'DOC' | translate | async}}</td>
            <td class="bold" *ngIf="system.SecondPmDate!=null"> {{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}} </td>
            <td class="bold" *ngIf="system.FloatingDate!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="system.FloatingDate!=null">{{'CMU' | translate | async}}<br>{{'DOC' | translate | async}}</td>
            <td class="bold" *ngIf="system.FloatingDate!=null"> {{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}} </td>
            <td class="bold" *ngIf="system.FloatingDate2!=null">{{'%Worn' | translate | async}}</td>
            <td class="bold" *ngIf="system.FloatingDate2!=null">{{'CMU' | translate | async}}<br>{{'DOC' | translate | async}}</td>
            <td class="bold" *ngIf="system.FloatingDate2!=null"> {{'Avg CMU' | translate | async}}<br> {{'Avg DOC' | translate | async}} </td>
            <td class="bold" *ngIf="system.Show100Worn"></td>
            <td class="bold" *ngIf="system.Show100Worn">{{'SMU' | translate | async}}</td>
            <td class="bold" *ngIf="system.Show100Worn">{{'DOE'|translate | async}}</td>
            <td class="bold" *ngIf="system.Show120Worn"></td>
            <td class="bold" *ngIf="system.Show120Worn">{{'SMU' | translate | async}}</td>
            <td class="bold" *ngIf="system.Show120Worn">{{'DOE'|translate | async}}</td>
          </tr>
          <tr *ngFor="let c of system.Components">
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo" [src]="sanitize(c.ComponentTypeImage)" />
              </div>
            </td>
            <td>
              <span title="{{c.Name}}">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}} </span>
            </td>
            <td>{{c.Position}}</td>

            <td *ngIf="system.ShowLastFourthInspection &&system.PreviousLastLastInspectionDate!=null"><span style="width: 80px;"
                [ngClass]="GetEvalColour(c, c.PrevLastLastWornPercentage,c.PreviousLastMeasurement)">
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.PreviousLastTool != 'Eval' "> {{c.PrevLastLastWornPercentage | number:'1.1-1'}}%</div>
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.PreviousLastTool == 'Eval' ">{{c.TrackEvalCodePreviousLastInspection}}</div>
              </span></td>
            <td *ngIf="system.ShowLastFourthInspection && system.PreviousLastLastInspectionDate!=null">{{c.PrevLastLastCMU}}<br>{{convertDistanceKmToMi(c.PrevLastLastDOC)}}</td>
            <td *ngIf="system.ShowLastFourthInspection && system.PreviousLastLastInspectionDate!=null">{{c.AvgCMUAtLastLast}}<br>{{c.AvgDOCAtLastLast}}</td>

            <td *ngIf="system.PreviousLastInspectionDate!=null">

<span *ngIf="!c.IsPreviousLastCalculated"
                style="width: 80px;" [ngClass]="GetEvalColour(c, c.PreviousLastInspectionWorn,c.PreviousLastMeasurement)">
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.PreviousLastTool != 'Eval' "> {{c.PreviousLastInspectionWorn | number:'1.1-1'}}%</div>
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.PreviousLastTool == 'Eval' ">{{c.TrackEvalCodePreviousLastInspection}}</div>
              </span>

              <span *ngIf="c.IsPreviousLastCalculated" style="width: 90px; border-style: double;border-width: thick;"
                [ngClass]="GetEvalColour(c, c.PreviousLastInspectionWorn,c.PreviousLastMeasurement)">
                <div style="text-align: -webkit-center !important ; display: inline-block; "
                  *ngIf="c.PreviousLastTool != 'Eval' "> {{c.PreviousLastInspectionWorn | number:'1.1-1'}}%</div>
                <div style="text-align: -webkit-center !important ; display: inline-block; "
                  *ngIf="c.PreviousLastTool == 'Eval' ">{{c.TrackEvalCodePreviousLastInspection}}</div>
              </span>

              <!-- <span style="width: 80px;"
                [ngClass]="GetEvalColour(c, c.PreviousLastInspectionWorn,c.PreviousLastMeasurement)">
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.PreviousLastTool != 'Eval' "> {{c.PreviousLastInspectionWorn | number:'1.1-1'}}%</div>
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.PreviousLastTool == 'Eval' ">{{c.TrackEvalCodePreviousLastInspection}}</div>
              </span> -->
            </td>
            <td *ngIf="system.PreviousLastInspectionDate!=null">{{c.PreviousLastInspectionCMU}}<br> {{convertDistanceKmToMi(c.PreviousLastInspectionDoC)}}</td>
            <td *ngIf="system.PreviousLastInspectionDate!=null">{{c.AvgCMUAtPrevLast}} <br> {{c.AvgDOCAtPrevLast}}</td>

            <td *ngIf="system.PreviousInspectionDate!=null">
              <span *ngIf="!c.PreviousMeasureCalculated"
                style="width: 80px;" [ngClass]="GetEvalColour(c, c.PreviousInspectionWorn,c.PreviousMeasurement)">
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.PreviousTool != 'Eval' "> {{c.PreviousInspectionWorn | number:'1.1-1'}}%</div>
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.PreviousTool == 'Eval' ">{{c.TrackEvalCodePreviousInspection}}</div>
              </span>

              <span *ngIf="c.PreviousMeasureCalculated" style="width: 90px; border-style: double;border-width: thick;"
                [ngClass]="GetEvalColour(c, c.PreviousInspectionWorn,c.PreviousMeasurement)">
                <div style="text-align: -webkit-center !important ; display: inline-block; "
                  *ngIf="c.PreviousTool != 'Eval' "> {{c.PreviousInspectionWorn | number:'1.1-1'}}%</div>
                <div style="text-align: -webkit-center !important ; display: inline-block; "
                  *ngIf="c.PreviousTool == 'Eval' ">{{c.TrackEvalCodePreviousInspection}}</div>
              </span>
            </td>
            <td *ngIf="system.PreviousInspectionDate!=null">{{c.PreviousInspectionCMU}}<br>{{ convertDistanceKmToMi(c.PreviousInspectionDoC)}}</td>
            <td *ngIf="system.PreviousInspectionDate!=null">{{c.AvgCMUAtPrev}} <br> {{c.AvgDOCAtPrev}}</td>


            <td *ngIf="system.LastInspectionDate!=null">
              <span *ngIf="!c.LastMeasureCalculated" style="width: 80px;"
                [ngClass]="GetEvalColour(c, c.LastInspectionWorn,c.LastMeasurement)">
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.LastTool != 'Eval'"> {{c.LastInspectionWorn | number:'1.1-1'}}%</div>
                <div style="text-align: -webkit-center !important ; display: inline-block;"
                  *ngIf="c.LastTool == 'Eval' ">{{c.TrackEvalCodeLastInspection}}</div>
              </span>

              <span *ngIf="c.LastMeasureCalculated" style="width: 90px; border-style: double;border-width: thick;"
                [ngClass]="GetEvalColour(c, c.LastInspectionWorn,c.LastMeasurement)">
                <div style="text-align: -webkit-center !important ; display: inline-block; "
                  *ngIf="c.LastTool != 'Eval'"> {{c.LastInspectionWorn | number:'1.1-1'}}%</div>
                <div style="text-align: -webkit-center !important ; display: inline-block; "
                  *ngIf="c.LastTool == 'Eval' ">{{c.TrackEvalCodeLastInspection}}</div>
              </span>
            </td>
            <td *ngIf="system.LastInspectionDate!=null">{{c.LastInspectionCMU}}<br>{{ convertDistanceKmToMi(c.LastInspectionDoC)}}</td>
            <td *ngIf="system.LastInspectionDate!=null">{{c.AvgCMUAtLast}} <br> {{c.AvgDOCAtLast}}</td>

            <td style="text-align: center">{{c.AverageCMU}}</td>

            <td style="text-align: center">{{c.AverageDoc}}</td>

            <td *ngIf="TodayDate!=null">
              <span style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important;"
                [ngClass]="GetEvalColour(c, c.ForecastWornPercentage)">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.ForecastWornPercentage | number:'1.1-1'}}%</div>

              </span>
            </td>
            <td *ngIf="TodayDate!=null">{{c.ForecastCMU}} <br>{{ convertDistanceKmToMi(c.ForecastDOC)}}</td>
            <td *ngIf="TodayDate!=null">{{c.AvgCMUAtToday}}<br>{{c.AvgDOCAtToday}}</td>

            <td *ngIf="system.NextPmDate!=null"><span *ngIf="!c.NextPmCalculated"
                style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important;"
                [ngClass]="GetEvalColour(c, c.NextPmWornPercentage)">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.NextPmWornPercentage | number:'1.1-1'}}%</div>

              </span>
              <span *ngIf="c.NextPmCalculated"
                style="border-style: double;border-width: thick; width: 75px; margin-right: 0px !important; padding: 8px 12px !important;border-style: double;border-width: thick;"
                [ngClass]="GetEvalColour(c, c.NextPmWornPercentage)">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.NextPmWornPercentage | number:'1.1-1'}}%</div>

              </span>
            </td>
            <td *ngIf="system.NextPmDate!=null">{{c.NextPmCMU}}<br>{{ convertDistanceKmToMi(c.NextPmDOC)}}</td>
            <td *ngIf="system.NextPmDate!=null">{{c.AvgCMUAtPm1Date}} <br>{{c.AvgDOCAtPm1Date}}</td>


            <td *ngIf="system.SecondPmDate!=null"><span *ngIf="!c.SecondPmCalculated"
                style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important;"
                [ngClass]="GetEvalColour(c, c.SecondPmWornPercentage)">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.SecondPmWornPercentage | number:'1.1-1'}}%</div>
              </span>
              <span *ngIf="c.SecondPmCalculated"
                style="border-style: double;border-width: thick; width: 75px; margin-right: 0px !important; padding: 8px 12px !important;"
                [ngClass]="GetEvalColour(c, c.SecondPmWornPercentage)">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.SecondPmWornPercentage | number:'1.1-1'}}%</div>
              </span>
            </td>
            <td *ngIf="system.SecondPmDate!=null">{{c.SecondPmCMU}}<br>{{ convertDistanceKmToMi(c.SecondPmDOC)}}</td>
            <td *ngIf="system.SecondPmDate!=null">{{c.AvgCMUAtSecPmDate}} <br>{{c.AvgDOCAtSecPmDate}}</td>

            <td *ngIf="system.FloatingDate!=null"> <span *ngIf="!c.FloatingCalculated"
                [ngClass]="GetEvalColour(c, c.FloatingPmWornPercentage)"
                style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important;">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.FloatingPmWornPercentage | number:'1.1-1'}}%</div>

              </span>
              <span *ngIf="c.FloatingCalculated" [ngClass]="GetEvalColour(c, c.FloatingPmWornPercentage)"
                style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important;border-style: double;border-width: thick;">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.FloatingPmWornPercentage | number:'1.1-1'}}%</div>

              </span>
            </td>
            <td *ngIf="system.FloatingDate!=null">{{c.FloatingPmCMU}}<br>{{ convertDistanceKmToMi(c.FloatingPmDOC)}}</td>
            <td *ngIf="system.FloatingDate!=null">{{c.AvgCMUAtFloating1}} <br>{{c.AvgDOCAtFloating1}}</td>


            <td *ngIf="system.FloatingDate2!=null">
              <span *ngIf="!c.Floating2Calculated" [ngClass]="GetEvalColour(c, c.FloatingPmWornPercentage2)"
                style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important;">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.FloatingPmWornPercentage2 | number:'1.1-1'}}%</div>

              </span>
              <span *ngIf="c.Floating2Calculated" [ngClass]="GetEvalColour(c, c.FloatingPmWornPercentage2)"
                style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important; border-style: double;border-width: thick;">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{c.FloatingPmWornPercentage2 | number:'1.1-1'}}%</div>

              </span>
            </td>
            <td *ngIf="system.FloatingDate2!=null">{{c.FloatingPmCMU2}}<br>{{ convertDistanceKmToMi(c.FloatingPmDOC2)}}</td>
            <td *ngIf="system.FloatingDate2!=null">{{c.AvgCMUAtFloating2}} <br>{{c.AvgDOCAtFloating2}}</td>

            <!-- <td *ngIf="system.FloatingDate2!=null">
              <table style="width: 100%;">
                <tr>
                  <td style="width:34%; text-align: center;">
                    <span *ngIf="!c.Floating2Calculated" [ngClass]="GetEvalColour(c, c.FloatingPmWornPercentage2)"
                      style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{c.FloatingPmWornPercentage2}}%</div>

                    </span>
                    <span *ngIf="c.Floating2Calculated" [ngClass]="GetEvalColour(c, c.FloatingPmWornPercentage2)"
                      style="width: 75px; margin-right: 0px !important; padding: 8px 12px !important; border-style: double;border-width: thick;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{c.FloatingPmWornPercentage2}}%</div>

                    </span>
                  </td>
                  <td style="width:33%; text-align: center;">{{c.FloatingPmCMU2}}</td>
                  <td style="width:33%; text-align: center;">{{c.FloatingPmDOC2}}</td>
                </tr>
              </table>
            </td> -->

            <td *ngIf="system.Show100Worn"> {{c.DateWorn100 | date: 'dd MMM yyyy'}}</td>
            <td *ngIf="system.Show100Worn">{{c.CMUWorn100}}</td>
            <td *ngIf="system.Show100Worn">{{c.DocWorn100}}</td>
            <!-- <td *ngIf="system.Show100Worn">
              <table style="width: 100%;">
                <tr>
                  <td style="width:34%; text-align: center;">
                    {{c.DateWorn100 | date: 'dd MMM yyyy'}}
                  </td>
                  <td style="width:33%; text-align: center;">{{c.CMUWorn100}}</td>
                  <td style="width:33%; text-align: center;">{{c.DocWorn100}}</td>
                </tr>
              </table>
            </td> -->
            <td *ngIf="system.Show120Worn"> {{c.DateWorn120 | date: 'dd MMM yyyy'}}</td>
            <td *ngIf="system.Show120Worn">{{c.CMUWorn120}}</td>
            <td *ngIf="system.Show120Worn">{{c.DocWorn120}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </panel>
</div>